import React, { useEffect, useState } from "react";
import { collection, getDocs, or, query, where } from "firebase/firestore";
import { db } from "../config/firebase";
import { useSearchParams } from "react-router-dom";
import { SwiperComp } from "../components/SwiperComp";
import { Search } from "../components/Search";
import { Loading } from "../components/Loading";

export const SearchPage = () => {
  const [response, setResponse] = useState(null);
  const [errMessage, setErrMessage] = useState("");
  const booksCollectionRef = collection(db, "Books");
  const [searchParams] = useSearchParams();
  const keywords = searchParams.get("keywords");

  useEffect(() => {
    const getBooks = async () => {
      try {
        const q = query(
          booksCollectionRef,
          or(where("author", "==", keywords), where("title", "==", keywords))
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.size === 0) {
          setResponse([]);
          setErrMessage(
            `No books or authors were found by keywords "${keywords}".`
          );
        } else {
          const resData = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          setResponse(resData);
          setErrMessage("");
        }
      } catch (error) {
        console.error("Error retrieving books:", error);
        setResponse([]);
        setErrMessage("An error occurred while retrieving books.");
      }
    };

    if (keywords) {
      getBooks();
    } else {
      setResponse([]);
      setErrMessage("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keywords]);

  return (
    <div className="flex flex-col p-5 sm:px-10 md:p-10">
      <div className="px-5 md:hidden sm:px-0">
        <Search />
      </div>
      <h2 className="text-4xl font-semibold text-center text-gray-950 py-5 mb-5">
        Searching for book
      </h2>
      {response === null ? (
        <Loading />
      ) : (
        <>
          {errMessage ? (
            <p className="text-xl text-center text-gray-600 mt-5">
              {errMessage}
            </p>
          ) : (
            <SwiperComp books={response} />
          )}
        </>
      )}
    </div>
  );
};
